export default "__VITE_ASSET__Bv0i8Zph__"